module.exports = __webpack_public_path__ + "static/pcg-hero-tablet.757e189e.webp";